import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, A } from '@contently/toolkit';

const InfoModal = props => {
  const { isOpen, onCancel } = props;

  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <ModalHeader>Brief templates</ModalHeader>
      <ModalBody>
        Brief templates allow you to speed up and standardize the brief creation process. By
        pre-selecting and saving fields and values you use frequently, you can use this template to
        create multiple briefs. You can have saved templates for specific campaigns, formats, tags
        etc. See{' '}
        <A
          href="https://contently-support.kayako.com/article/985-what-are-brief-templates-and-how-do-i-set-them-up"
          title="Creating editing and collaborating with content brief templates"
        >
          here
        </A>{' '}
        for more information on how to use this feature.
      </ModalBody>
    </Modal>
  );
};

InfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default InfoModal;



// WEBPACK FOOTER //
// ./app/javascript/app/components/brief_templates/info_modal.jsx